"use client";

import * as React from "react";

import { useNewsletter } from "@stadium/services/hubspot/hooks/use-newsletter";

import TextInput from "@stadium/ui/src/components/form/TextInput";

import Button from "@stadium/shared/src/components/shared/button";

import styles from "../main.module.scss";

interface NewsletterProps {
  title?: string;
  placeholder?: string;
  buttonAriaLabel?: string;
  inputWrapperClassName?: string;
  containerClassName?: string;
}

const Newsletter = ({
  title,
  placeholder,
  buttonAriaLabel,
  inputWrapperClassName,
  containerClassName,
}: Readonly<NewsletterProps>) => {
  const {
    email,
    isSubmitting,
    isSubmitted,
    errorMessage,
    handleSubmit,
    handleKeyDown,
    handleChange,
  } = useNewsletter();

  if (!title) return null;

  if (isSubmitted) {
    return (
      <div className={containerClassName}>
        <p className={styles.newsletterTitle}>{title}</p>
        <p className={styles.newsletterSuccessMessage}>Thank you for subscribing!</p>
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      <p className={styles.newsletterTitle}>{title}</p>
      <div className={styles.inputWithError}>
        <div className={inputWrapperClassName}>
          <TextInput
            placeholder={placeholder}
            className={styles.footerInput}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
            value={email}
            type="no-style"
          />
          <Button
            styleType="no-style"
            aria-label={buttonAriaLabel}
            className={styles.newsletterButton}
            onClick={handleSubmit}
            disabled={!email || isSubmitting}
          >
            <span className={styles.formArrow} />
          </Button>
        </div>
        {errorMessage && <p className={styles.newsletterErrorMessage}>{errorMessage}</p>}
      </div>
    </div>
  );
};

export default Newsletter;
